// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_f8-6";
export var emphasizeQuantity = "_f8-3";
export var flatBottomCorners = "_f8-5";
export var productImage = "_f8-0";
export var quantityContainer = "_f8-2";
export var tooltip = "_f8-1";
export var wrapAndEllipsesOverflow = "_f8-4";